import {
  ArticleInformalFeedbackReviewsCreatedEvent,
  ArticleInformalFeedbackRequestClosedEvent,
  ArticleInformalFeedbackReviewSubmittedEvent,
  ArticleInformalFeedbackReviewDismissedEvent,
} from './Types'
import { ReactComponent as EyeIcon } from './icons/eye.svg'
import { IconButton } from 'components/IconButton/IconButton'
import { useHistory } from 'react-router-dom'
import { ArticleInformalFeedbackViewersCreatedEvent, ArticleInformalFeedbackViewersCoCreatedEvent } from './Types'
import { useReviewsRoutes } from 'hooks/useReviewsRoutes'

interface Props {
  event:
    | ArticleInformalFeedbackReviewsCreatedEvent
    | ArticleInformalFeedbackViewersCreatedEvent
    | ArticleInformalFeedbackViewersCoCreatedEvent
    | ArticleInformalFeedbackReviewSubmittedEvent
    | ArticleInformalFeedbackReviewDismissedEvent
    | ArticleInformalFeedbackRequestClosedEvent
}

const InformalFeedbackRequestAction = ({ event }: Props) => {
  const { request_id } = event.data
  const { slug } = event.article
  const history = useHistory()
  const reviewRoutes = useReviewsRoutes()

  return (
    <IconButton
      variant="secondaryGrey"
      icon={EyeIcon}
      aria-label="View analytics"
      onPress={() => {
        history.push(reviewRoutes.show({ slug, reviewId: request_id }))
      }}
    />
  )
}

export { InformalFeedbackRequestAction }
